import type { BookTrim } from '@app/studio'
import { Sheet } from '../../ui/Sheet'
import { SheetProof } from '../../ui/SheetProof'

/** The rendered book, fetched and held at its finished trim geometry. */
export function BookPreviewSheet({
  url,
  trim,
  onClose,
  onPrint,
}: {
  url: string
  trim: BookTrim
  onClose: () => void
  onPrint: () => void
}) {
  return (
    <Sheet
      title="Preview"
      size="doc"
      onClose={onClose}
      primary={{ label: 'Print book', onSelect: onPrint }}
      secondary={{ label: 'Close', onSelect: onClose }}
    >
      <SheetProof url={url} flowing page={trim} />
    </Sheet>
  )
}
